/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList, simpleLocalAttribute } from '@touchplan/common';
import { DefaultSplitDataRenderType, SplitData } from '@touchplan/common';
import { Organization } from './Organization';
import { User } from '@touchplan/common';

// Path: /organizations/organizationId
export interface IBaseOrganizationMemberFields {
	userId: string;
	organizationId: string;
	orgAccessLevel: string;
	projectMembers: { [key: string]: string };
}

export interface IOrganizationMemberFields extends IBaseOrganizationMemberFields {
	organization: Organization;
	user: User;
}

export class OrganizationMember extends SplitData<IOrganizationMemberFields, DefaultSplitDataRenderType> {
	protected useInPlace = true;
	protected attributeList = Object.assign(
		generateSimplestList(['userId', 'organizationId', 'orgAccessLevel', 'projectMembers']),
		{
			organization: simpleLocalAttribute,
			user: simpleLocalAttribute,
		}
	);

	constructor(id: string) {
		super(id, DefaultSplitDataRenderType.database);
	}
}
